import { Stack } from "react-bootstrap";
import styles from "./action-card.module.scss";
import { Icon } from "react-feather";


interface ActionCardProps {
  IconComponent: Icon;
  title: string;
  variant: "default" | "contained";
  onClick?: () => void;
}

export function ActionCard({
  IconComponent,
  title,
  variant,
  onClick,
}: ActionCardProps) {
  return (
    <Stack
      direction="vertical"
      className={`${styles["action-card"]} ${styles[variant]}`}
      onClick={onClick}
    >
      <IconComponent width={20} height={20} data-testid={"icon"} />
      <div>{title}</div>
    </Stack>
  );
}
